import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { share } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { HTTP_TIMEOUT } from '../../interceptor/timeout.interceptor';
import {
  CarTripModel,
  FlightTripModel,
  TripOptions,
  UpcomingTrips,
  VacationTripModel
} from '../../model/upcoming-trip.model';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class UpcomingTripService {
  upComingTrips: UpcomingTrips;
  upcomingTripDataChanged = new EventEmitter<any>();
  private nmbrOfTrips = '1';

  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private datalayer: DataLayer
  ) {}

  getTripDetails(skymileno) {
    const tripoptions = new TripOptions(skymileno, this.nmbrOfTrips);
    if (this.upComingTrips) {
      return this.upComingTrips;
    } else {
      this.getTripDetailsFromAPI(tripoptions).subscribe(
        (data) => {
          if (data) {
            this.upComingTrips = new UpcomingTrips();
            let conditionArr = [
              {
                condition: () => data['totalTrips'],
                action: () =>
                  (this.upComingTrips.totaltrips = data['totalTrips'])
              },
              {
                condition: () => data['transactionId'],
                action: () =>
                  (this.upComingTrips.transactionId = data['transactionId'])
              },
              {
                condition: () => data['viewAllTripsLink'],
                action: () =>
                  (this.upComingTrips.viewAlltrips = data['viewAllTripsLink'])
              },
              {
                condition: () => data['carTrip'],
                action: () => {
                  const carTrip = data['carTrip'];
                  this.upComingTrips.carTripDetails = new CarTripModel(
                    carTrip.detailsLink,
                    carTrip.dateRange,
                    carTrip.pickupCity,
                    carTrip.vendorConfirmationNbr,
                    carTrip.vendorName
                  );
                  if (this.upComingTrips.carTripDetails.vendorName) {
                    this.upComingTrips.carTripDetails.vendorName =
                      this.upComingTrips.carTripDetails.vendorName.toLowerCase();
                  }
                  this.upComingTrips.hasUpComingTrip = true;
                }
              },
              {
                condition: () => data['trip'],
                action: () => {
                  this.upComingTrips.hasUpComingTrip = true;
                  const flightTrip = data['trip'];
                  this.upComingTrips.flightTripDetails = new FlightTripModel(
                    flightTrip.checkedIn,
                    flightTrip.checkinEligible,
                    flightTrip.checkinLink,
                    flightTrip.dateRange,
                    flightTrip.destinationCity,
                    flightTrip.detailsLink,
                    flightTrip.iropClean,
                    flightTrip.iropImpact,
                    flightTrip.iropMessage,
                    flightTrip.pnrNbr
                  );
                }
              },
              {
                condition: () => data['vacationTrip'],
                action: () => {
                  this.upComingTrips.hasUpComingTrip = true;
                  const vacationTrip = data['vacationTrip'];
                  this.upComingTrips.vacationTripDetails =
                    new VacationTripModel(
                      vacationTrip.checkedIn,
                      vacationTrip.checkinEligible,
                      vacationTrip.checkinLink,
                      vacationTrip.dateRange,
                      vacationTrip.destinationCityName,
                      vacationTrip.detailsLink,
                      vacationTrip.iropClean,
                      vacationTrip.iropImpact,
                      vacationTrip.iropMessage,
                      vacationTrip.vacationConfirmationNbr
                    );
                }
              }
            ];

            conditionArr.filter((obj) => {
              if (obj.condition()) {
                obj.action();
              }
            });

            this.upcomingTripDataChanged.emit({
              data: this.upComingTrips,
              error: null
            });
            this.datalayer.upcomingTripData =
              this.upComingTrips.flightTripDetails;
            this.datalayer.compile();
            this.datalayer.init();
          }
        },
        (err) => {
          this.upcomingTripDataChanged.emit({ data: null, error: err });
        }
      );
    }
  }

  getTripDetailsFromAPI(tripoptions) {
    const svcTimeOut: number = Number.parseInt(
      this.config.get('APP_TIMEOUT_SLOW')
    );
    const retries: number = Number.parseInt(this.config.get('APP_RETRIES'));

    const requestOptions = {
      headers: new HttpHeaders(),
      params: new HttpParams()
    };
    requestOptions.headers.set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    requestOptions.headers.append('Accept', 'application/json');
    requestOptions.headers.append(HTTP_TIMEOUT, svcTimeOut.toString());
    return this._http
      .post(
        `${this.config.get('APP_TRIPS_UPCOMING_TRIP_URL')}?skymilesNbr=${
          tripoptions.skymilesNbr
        }&nmbrOfTrips=${tripoptions.nmbrOfTrips}`,
        null,
        requestOptions
      )
      .pipe(share());
  }
}
